import updateAccountGroupInput from './common/update-account-group-input'
import updateAttachmentGroupInput from './common/update-attachment-group-input'
import updateAccountMasterGroupInput from '@app/application/export/behaviours/export-form-tools/widgets/account/common/update-account-master-group-input'

export default () => {
  $('table.export-accounts-table').each(function () {
    const table = $(this)

    updateAccountGroupInput(table)
    updateAttachmentGroupInput(table)
  })

  $('.check-master-group').each(function () {
    const group = $(this)

    updateAccountMasterGroupInput(group)
  })
}
